export default "__VITE_ASSET__cc1343d6__"